import { HarvestTypes } from "@gtpl/shared-models/common-models";
import { CompanyCategoryEnum } from "../rm-count-pricelist";

export class RmRatesInfoReq {
    indentId : number;
    harvestType?: HarvestTypes
    category ?: CompanyCategoryEnum
    count ?: number
    indentDate?:any

    constructor(indentId : number,harvestType?: HarvestTypes,category ?: CompanyCategoryEnum,count ?: number,indentDate?:any){
        this.indentId = indentId
        this.harvestType = harvestType
        this.category = category
        this.count = count
        this.indentDate = indentDate
    }
}